import { createContext, useState , useEffect } from "react";
import { useLocation , useNavigate } from 'react-router-dom';
import axios from "axios";

const ThemeContext = createContext();

export const  Context = ({children}) =>{
  const [data, setData] = useState([]);
     const location = useLocation();
    const [theme ,setTheme] =useState("dark")
    const [mobilHeader ,setmobilHeader] = useState("h2h")
    const [mobilHeaderPanel ,setmobilHeaderPanel] = useState(false)
    const [mobilHeaderPanelImage ,setmobilHeaderPanelImage] = useState("./h2h.png") 
     const [LanguageModelDis ,  setLanguageModelDis] = useState(false);
     

    useEffect(()=> {

      // if(!sessionStorage.getItem("left-menu")  ){
      //     sessionStorage.setItem("left-menu", false)
      // }
      // else{

      // }

            if(location.pathname.split("/")[1] == "Overview") {
              setmobilHeader("Overview")
             setmobilHeaderPanelImage("/paper.png")
           }
           else if(location.pathname.split("/")[1] == "Fixture"){
            setmobilHeader("Fixture")
            setmobilHeaderPanelImage("/calendar.png")
          }

          else if(location.pathname.split("/")[1] == "Table"){
            setmobilHeader("Table")
            setmobilHeaderPanelImage("/menuHead.png")
          }

          else if(location.pathname.split("/")[1] == "Team"){
            setmobilHeader("Teams")
            setmobilHeaderPanelImage("/jersey.png")
          }

          else if(location.pathname.split("/")[1] == "Info"){
            setmobilHeader("Information")
            setmobilHeaderPanelImage("/Information.png")
          }

          else if(location.pathname.split("/")[1] == "Archive"){
            setmobilHeader("Archive")
            setmobilHeaderPanelImage("/archive.png")
          }

          else{
              setmobilHeader("h2h")
              setmobilHeaderPanelImage("/h2h.png")
          }
       })


    const values = {
    theme ,
    setTheme,
    mobilHeader,
    setmobilHeader,
    mobilHeaderPanel,
    setmobilHeaderPanel,
    mobilHeaderPanelImage,
    LanguageModelDis,
    setLanguageModelDis
    
}
      return  <ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>;
}

export default ThemeContext;
